module.exports = __webpack_public_path__ + "static/media/icon-drydooropen.34b69180.svg";